// src/components/ConfirmLogoutModal.jsx
import React from "react";
import { useTranslation } from "react-i18next";

export default function ConfirmLogoutModal({ open, onConfirm, onCancel }) {
  const { t } = useTranslation();

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onCancel}
        aria-hidden="true"
      />
      <div className="relative z-[101] w-full max-w-md rounded-lg border border-[#444] bg-[#2C2C2C] p-5 shadow-xl">
        <h3 className="text-lg text-white mb-5">{t("confirmLogout.title")}</h3>
        <p className="text-sm text-[#DDD] mb-5">{t("confirmLogout.message")}</p>
        <div className="flex gap-3 justify-center">
          <button
            onClick={onCancel}
            className="px-4 py-2 rounded-md bg-[#3A3A3A] hover:bg-[#333] text-white"
          >
            {t("confirmLogout.cancel")}
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 rounded-md bg-red-500 hover:bg-red-600 text-white"
          >
            {t("confirmLogout.logout")}
          </button>
        </div>
      </div>
    </div>
  );
}
